import React from 'react';

import { useEffect } from 'react';
const LegalDisclaimerPage = () => {
    useEffect(() => {
  // גלילה חלקה לראש העמוד
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">דיסקליימר משפטי (כתב ויתור מאחריות)</h1>
          <p className="text-gray-700 text-center mb-6">עודכן לאחרונה: יולי 2025</p>

          <div className="prose prose-lg max-w-none" dir="rtl">
            <p className="text-gray-700 leading-relaxed mb-6">
              האתר "גמלנט AI" ("האתר", "השירות", "אנחנו", "מפעיל האתר") מספק מידע אינפורמטיבי כללי, השוואות ודירוגים בנושאי חיסכון והשקעות בישראל. דיסקליימר זה מהווה תשתית משפטית מחייבת, והוא חל על כל שימוש באתר, בכל מכשיר, מדינה או הקשר. כל שימוש באתר כפוף לדיסקליימר זה, ומהווה הסכמה לתנאים המפורטים בו.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. אין ייעוץ השקעות או המלצה אישית</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                המידע באתר נועד לצרכים אינפורמטיביים בלבד ואינו מהווה ייעוץ השקעות ו/או ייעוץ פנסיוני ו/או שיווק השקעות ו/או ייעוץ מס ו/או המלצה מותאמת אישית – כמשמעותם בחוק הסדרת העיסוק בייעוץ השקעות, התשנ"ה–1995.
              </li>
              <li>
                הדירוגים ו/או ההשוואות ו/או הנתונים ו/או כל תוצאה שמופקת מן האלגוריתם – אינם מהווים תחליף להיוועצות עם בעל רישיון השקעות ו/או יועץ מוסמך.
              </li>
              <li>
                מפעיל האתר אינו בוחן את צרכיו האישיים, מצבו הכלכלי או מטרות ההשקעה של המשתמש, ואינו מתחייב לתוצאה כלשהי.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. מקור הנתונים ודיוקם</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                הנתונים המוצגים באתר מבוססים, בין היתר, על מקורות ציבוריים כגון גמל-נט, פנסיה-נט וביטוח-נט. המידע נאסף, מעובד ומדורג באמצעות אלגוריתם עצמאי, אך יתכנו אי דיוקים, השמטות, עדכונים חלקיים או טעויות.
              </li>
              <li>
                מפעיל האתר אינו נושא באחריות כלשהי למהימנות, דיוק, שלמות או עדכניות הנתונים – והמשתמש מצהיר כי הוא מבין ומקבל זאת.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. שימוש על אחריות המשתמש בלבד</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                השימוש באתר, לרבות הסתמכות על מידע, דירוגים, תצוגות או חישובים – נעשה על אחריות המשתמש בלבד.
              </li>
              <li>
                המשתמש מוותר מראש ובאופן בלתי חוזר על כל טענה, תביעה, דרישה או סעד – מכל סוג שהוא – כנגד מפעיל האתר, הנובעים משימוש באתר, מהסתמכות על תכניו או מהיעדר תוצאה מסוימת.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. היעדר התחייבות משפטית, כספית או תוצאתית</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                מפעיל האתר אינו מתחייב:
                <ul className="list-disc list-inside text-gray-700 space-y-2 pr-6">
                  <li>לזמינות רציפה של האתר או הנתונים</li>
                  <li>להתאמה לצרכי המשתמש</li>
                  <li>להימנעות מתקלות, באגים או שיבושים</li>
                  <li>לרווחיות, שיפור מצב פיננסי או הצלחה בהשקעה</li>
                </ul>
              </li>
              <li>
                כל החלטה של המשתמש, לרבות פתיחת חשבון, שינוי מסלול השקעה, בחירת גוף פיננסי או כל פעולה אחרת – תיעשה לפי שיקול דעתו, באחריותו הבלעדית, ולאחר בדיקה עצמאית.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. קניין רוחני</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                האלגוריתם, הדירוגים, הממשק, הסיווגים והמתודולוגיה שבבסיס האתר – מהווים יצירה מקורית המוגנת בזכויות יוצרים, סוד מסחרי וחוק עוולות מסחריות.
              </li>
              <li>
                כל ניסיון לשכפל, להעתיק, להנדס לאחור, להשתמש או לפרסם מידע זה ללא אישור מראש ובכתב – מהווה הפרת זכויות ועילה לתביעה משפטית.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. שיתופי פעולה, תגמולים ופרסומות (בעתיד)</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                נכון למועד זה, אין באתר פרסומות, קישורים ממומנים או תגמולים מסחריים. ככל שיתווספו בעתיד – יינתן גילוי נאות והמשתמש יידרש להסכים לכך מראש.
              </li>
              <li>
                האתר עשוי להציג בעתיד קישורים, שיתופי פעולה או אזכורים של גופים פיננסיים – ואין בכך כדי להוות המלצה או עדיפות של גוף אחד על פני אחר.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. הגבלת אחריות</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                מפעיל האתר לא יישא באחריות בגין כל נזק – ישיר, עקיף, נלווה, מיוחד, תוצאתי או כספי – שייגרם כתוצאה מהשימוש באתר, לרבות:
                <ul className="list-disc list-inside text-gray-700 space-y-2 pr-6">
                  <li>הפסד כספי, אובדן השקעה, או כשלון בתשואות</li>
                  <li>טעויות בתצוגת נתונים או בדירוג</li>
                  <li>שיבוש טכני, פרצה אבטחתית או תקלה</li>
                  <li>הסתמכות על תכנים או השוואות</li>
                </ul>
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">8. הבהרה</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                כל סעיף מדיסקליימר זה יפורש באופן עצמאי; פסלות חלק אחד לא תשפיע על תקפות היתר.
              </li>
              <li>
                הדין החל הוא הדין הישראלי בלבד, והסמכות המקומית נתונה לבתי המשפט במחוז תל־אביב–יפו בלבד.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">9. יצירת קשר</h2>
            <p className="text-gray-700 leading-relaxed">
              לשאלות משפטיות, בקשות הבהרה או הודעות רשמיות – ניתן לפנות דרך{' '}
              <a href="/contact" className="text-blue-600 hover:text-blue-800">טופס "צור קשר" באתר</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalDisclaimerPage;